import { ref, onMounted, onUnmounted, watch } from "vue";
import { ESP32BLEBluetooth } from "@/services/domainControl";
import { useDomainControlStore } from "@/stores/domainControl";
import { Loading } from "quasar";
import { parseSignalObject } from "@/views/DomainControl/helper/signalTransform";
import { setupTimeInterval } from "@/composables/timer";
import { useRoute } from "vue-router";

interface Props {
  handleNotify: (data: any) => void;
  parseOutputValue: (outputValue: DomianControl.OutputValue) => any;
  SERVICE_UUID: BluetoothServiceUUID;
  NOTIFY_UUID: BluetoothServiceUUID;
}

const useInitialize = ({
  handleNotify,
  SERVICE_UUID,
  NOTIFY_UUID,
  parseOutputValue,
}: Props) => {
  const route = useRoute();
  const isNotifyed = ref(true);
  const domainControlStore = useDomainControlStore();
  const { updateTimeInterval } = setupTimeInterval();
  const handleNotifyAndSignalTransform = (data: any) => {
    domainControlStore.printInterval && updateTimeInterval(); // 显示时间间隔
    // 转换信号
    data = parseSignalObject(data, domainControlStore.printLog);
    handleNotify(data);
  };

  const startNotifications = async () => {
    await ESP32BLEBluetooth.startNotifications(
      handleNotifyAndSignalTransform,
      SERVICE_UUID,
      NOTIFY_UUID
    );
    isNotifyed.value = true;
  };

  const stopNotifications = async () => {
    await ESP32BLEBluetooth.stopAllNotifications();
    isNotifyed.value = false;
  };

  const init = async () => {
    if (!domainControlStore.isConnected) {
      return;
    }
    Loading.show();
    try {
      await stopNotifications();
      // 告诉后端是哪个页面
      await ESP32BLEBluetooth.queuePerformReadData(SERVICE_UUID, NOTIFY_UUID, {
        showRawRes: true,
      });
      // await new Promise((r) => setTimeout(r, 1000, true)); // 等一秒钟
       await startNotifications();
      const outputValue = await domainControlStore.readOutputValue();
      if (outputValue) {
        parseOutputValue(outputValue);
      }
    } catch (error) {
      Loading.hide();
      console.error("[BOWEN_LOG] 🚀 ~~ useInitialize init ~~ error:", error);
    }
    if (route.name === "TAA") {
      await domainControlStore.writeOutputValue({
        UITx_DMC_Ena: 1, // dTCS
      });
    }
    Loading.hide();
  };

  onMounted(() => {
    init();
  });

  onUnmounted(() => {
    isNotifyed.value = false;
    // if (domainControlStore.isConnected) {
    //   stopNotifications();
    // }
  });

  // 监听 isConnected 变化
  watch(
    () => domainControlStore.isConnected,
    (newValue) => {
      if (newValue) {
        init();
      }
    }
  );

  return {
    startNotifications,
    stopNotifications,
    isNotifyed,
    init,
  };
};

export default useInitialize;
